




































































































































































import { mapActions, mapState } from 'vuex';
import { debounce } from 'lodash-es';

import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import SelectCard from '@adobe/edex/frontend/views/course/settings/course-settings-select-card.vue';
import { deleteCourse } from '@adobe/edex/frontend/api/course';
import { cdn } from '@adobe/edex/ui/shared/frontend/utils/cdn';
import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';
import {
  checkObjectArrayDiff,
  splitPrimarySecondary,
  getID,
} from '@adobe/edex/frontend/views/course/settings/constants';
import { getProductIconURL } from '@adobe/edex/ui/shared/frontend/utils';

const getInitialState = initialCourse => ({
  products: initialCourse.products,
  subjects: initialCourse.subjects,
  academicLevels: initialCourse.academicLevels,
  contentStandards: initialCourse.contentStandards,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  components: {
    SelectCard,
  },
  computed: {
    ...mapState('metadata', {
      contentStandardsMetaData: 'contentStandards',
    }),
  },
  async created() {
    if (!this.contentStandardsMetaData) {
      await this.fetchByType(MetadataType.contentStandards);
    }
  },
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    getProductIconURL,
    onMetaChanged({ name, data }) {
      this[name] = data;
    },
    resetIndividual(name) {
      this[name] = this.initialCourse[name];
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
    getSubjectURL(url) {
      return `${cdn}/v3/images/badges/subjects/${url}`;
    },
    async handleDeleteCourse() {
      this.$modal.show('dialog', {
        title: 'Delete Course?',
        text: 'Are you sure you want to delete this course?',
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
          {
            title: 'Confirm',
            default: true,
            handler: async () => {
              try {
                await deleteCourse(this.initialCourse.id);

                this.$router.push(
                  this.rDecor({
                    name: 'landing',
                  })
                );
              } catch (e) {
                console.log(e);
              }

              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
  },
  watch: {
    ...['products', 'subjects', 'academicLevels'].reduce((acc, name) => {
      acc[name] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name,
            data: splitPrimarySecondary(current),
            hasDiff: checkObjectArrayDiff(this.initialCourse[name], current),
          });
        }
      };

      return acc;
    }, {}),
    ...['contentStandards'].reduce((acc, name) => {
      acc[name] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name,
            data: current.map(getID),
            hasDiff: checkObjectArrayDiff(this.initialCourse[name], current),
          });
        }
      };
      return acc;
    }, {}),
  },
};
